(function () {
  function init(root) {
    var track = root.querySelector('[data-rw-track]');
    if (!track) return;
    function step() { var c = track.querySelector('.rw-review'); return c ? c.getBoundingClientRect().width + 22 : 300; }
    var prev = root.querySelector('[data-rw-prev]'), next = root.querySelector('[data-rw-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  }
  function start() { document.querySelectorAll('[data-rw-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
